import {request, setAuthInHeader} from "@/api/request";
import EventBus from "../mixins/event-bus";

const state = {
    parcelList: {},
    parcelListIsGet:false,
};

const getters = {
    getParcelList: state => state.parcelList,
};

const mutations = {
    updateParcelList(state, obj) {
        state.parcelList = obj.value;
    },
    resetParcelList(state) {
        state.parcelList = {};
    },

};

const actions = {
    setParcelList({commit, rootState, dispatch}, {}) {
        request.get('order/category/express', {})
            .then((res) => {
                let result = res.data.Data.Result;
                if (result.Info.Type > 0 && result.List.length > 0) {
                    let parcelList = result.List;
                    commit('updateParcelList', {'value': parcelList});
                } else {
                    commit('updateParcelList', {'value': {}})
                }
            }, () => {
                console.log('error');
            })
    },
    changeParcelList({commit, rootState}, {data}) {
        commit('updateParcelList', {'value': data});
    },
    initParcelList({commit, rootState}, {data}) {
        commit('resetParcelList');
    },

};

export default {namespaced: true, state, getters, mutations, actions}
